import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { ExpandableDescription } from './components/expandable-description/ExpandableDescription';
import { EventDetailsSummary } from './components/event-details-summary/EventDetailsSummary';
import { SpotAvailabilityLine } from './components/event-details-summary/SpotAvailabilityLine';
import { ActionButton } from './components/action-button/ActionButton';
import { UndoActionButton } from './components/undo-action-button/UndoActionButton';
import { BookEventGuestCounter } from './components/book-event/guest-counter/BookEventGuestCounter';
import { BookSpot } from './components/book-spot/BookSpot';
import { BookSpotSuccess } from './components/book-spot/BookSpotSuccess';
import { isSpotBookingEnabledForBookingDetails } from '@glofoxinc/room-layout-map/interactiveSpotBooking';
import type { ComponentType } from 'react';
import {
  resolveMemberSpotFromBookingRecord,
  type RoomLayoutMapProps,
} from '@glofoxinc/room-layout-map/interactiveSpotBooking';
import { LabeledCheckbox } from './components/labeled-checkbox/LabeledCheckbox';
import { MobileHeader } from './components/mobile-header/MobileHeader';
import { HorizontalScrollTabs } from './components/horizontal-scroll-tabs/HorizontalScrollTabs';
import { ModalHeader } from './components/modal-header/ModalHeader';

type WebReactRegistry = {
  __React?: typeof React;
  __ReactDOM?: typeof ReactDOMClient;
  ExpandableDescription?: typeof ExpandableDescription;
  EventDetailsSummary?: typeof EventDetailsSummary;
  SpotAvailabilityLine?: typeof SpotAvailabilityLine;
  ActionButton?: typeof ActionButton;
  UndoActionButton?: typeof UndoActionButton;
  BookEventGuestCounter?: typeof BookEventGuestCounter;
  BookSpot?: typeof BookSpot;
  BookSpotSuccess?: typeof BookSpotSuccess;
  isSpotBookingEnabledForBookingDetails?: typeof isSpotBookingEnabledForBookingDetails;
  RoomLayoutMap?: ComponentType<{ data: RoomLayoutMapProps }>;
  resolveMemberSpotFromBookingRecord?: typeof resolveMemberSpotFromBookingRecord;
  LabeledCheckbox?: typeof LabeledCheckbox;
  MobileHeader?: typeof MobileHeader;
  HorizontalScrollTabs?: typeof HorizontalScrollTabs;
  ModalHeader?: typeof ModalHeader;
};

declare global {
  interface Window {
    WebReactComponents?: WebReactRegistry;
  }
}

function registerGlobals() {
  if (typeof window === 'undefined') {
    return;
  }

  const registry: WebReactRegistry = window.WebReactComponents ?? {};
  window.WebReactComponents = registry;
  registry.__React = React;
  registry.__ReactDOM = ReactDOMClient;
  registry.ExpandableDescription = ExpandableDescription;
  registry.EventDetailsSummary = EventDetailsSummary;
  registry.SpotAvailabilityLine = SpotAvailabilityLine;
  registry.ActionButton = ActionButton;
  registry.UndoActionButton = UndoActionButton;
  registry.BookEventGuestCounter = BookEventGuestCounter;
  registry.BookSpot = BookSpot;
  registry.BookSpotSuccess = BookSpotSuccess;
  registry.resolveMemberSpotFromBookingRecord = resolveMemberSpotFromBookingRecord;
  registry.isSpotBookingEnabledForBookingDetails = isSpotBookingEnabledForBookingDetails;
  registry.LabeledCheckbox = LabeledCheckbox;
  registry.MobileHeader = MobileHeader;
  registry.HorizontalScrollTabs = HorizontalScrollTabs;
  registry.ModalHeader = ModalHeader;
}

registerGlobals();
